// import React, { useEffect, useState } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import { get } from "../../../utils/api";
// import { startCase } from "lodash";
// import { Typography, Box, Paper, Divider, Grid, Button } from "@mui/material";
// import moment from "moment";
// import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined"; // Use a modern icon for a premium look

// export default function DetailsModule(props: any) {
//   console.log("props", props);
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [formData, setFormData] = useState<any>({});
//   const [fields, setFields] = useState<Array<any>>([]);

//   useEffect(() => {
//     getFields();
//   }, [props.module]);

//   const getFields = async () => {
//     try {
//       const response = await get(`${props.module}`, {});
//       setFields(response.data.fields); // Set the field settings
//       getData();
//     } catch (error) {
//       console.log("Error fetching fields: ", error);
//     }
//   };

//   const getData = async () => {
//     let params = { [props.primary_key]: id };
//     try {
//       const response = await get(`${props.module}/details`, params);
//       setFormData(response.data); // Set the detailed form data
//     } catch (error) {
//       console.log("Error fetching data: ", error);
//     }
//   };

//   // Render object fields based on their mapped collection
//   const renderMappedObject = (
//     mappedData: any[],
//     primary_name_field: string
//   ) => {
//     if (!Array.isArray(mappedData) || mappedData.length === 0) {
//       return "N/A";
//     }

//     return (
//       <ul>
//         {mappedData.map((item, index) => (
//           <li key={index}>{item[primary_name_field] || "N/A"}</li>
//         ))}
//       </ul>
//     );
//   };

//   // Function to render a generic array of objects as an HTML table
//   const renderGenericTable = (data: Array<Record<string, any>>) => {
//     // Check if data is valid and not empty
//     console.log(data);
//     if (!Array.isArray(data) || data.length === 0) {
//       return <p>No data available.</p>;
//     }

//     // Extract the keys from the first object to use as table headers
//     const headers = Object.keys(data[0]);

//     return (
//       <table
//         style={{
//           width: "100%",
//           borderCollapse: "collapse",
//           marginBottom: "20px",
//         }}
//       >
//         <thead>
//           <tr>
//             {headers.map((header, index) => (
//               <th
//                 key={index}
//                 style={{
//                   padding: "10px",
//                   borderBottom: "2px solid #333",
//                   textAlign: "left",
//                   backgroundColor: "#f4f4f4",
//                 }}
//               >
//                 {header.charAt(0).toUpperCase() + header.slice(1)}
//               </th>
//             ))}
//           </tr>
//         </thead>
//         <tbody>
//           {data.map((row, rowIndex) => (
//             <tr key={rowIndex}>
//               {headers.map((header, colIndex) => (
//                 <td
//                   key={colIndex}
//                   style={{
//                     padding: "10px",
//                     borderBottom: "1px solid #ddd",
//                   }}
//                 >
//                   {row[header] !== null && row[header] !== undefined
//                     ? row[header].toString()
//                     : "N/A"}
//                 </td>
//               ))}
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     );
//   };

//   // Function to render field values based on field type
//   const renderField = (field: any, value: any) => {
//     console.log(field, value);
//     switch (field.type) {
//       case "String":
//         return value || "N/A";
//       case "Number":
//         return value || "N/A";
//       case "Date":
//         return value ? moment(value).format("DD-MMM-YYYY") : "N/A";
//       case "Object":
//         if (
//           field.type === "Object" &&
//           field.ui_element_type == "key-value-select"
//         ) {
//           return renderGenericTable(value);
//         } else if (field.mapped_collection) {
//           if (field.mapped_collection.multiple) {
//             return renderMappedObject(
//               value || [],
//               field.mapped_collection.primary_name_field
//             );
//           }
//           return value
//             ? value[field.mapped_collection.primary_name_field]
//             : "N/A";
//         }
//         return typeof value === "object" ? JSON.stringify(value) : "N/A";
//       default:
//         return "N/A";
//     }
//   };

//   return (
//     <Box
//       sx={{ marginTop: 4, paddingLeft: 3, paddingRight: 3, paddingBottom: 6 }}
//     >
//       <Typography
//         variant="h4"
//         sx={{
//           marginBottom: 4,
//           fontWeight: "600",
//           color: "#333",
//           fontSize: "2.2rem",
//           letterSpacing: "0.5px",
//           textTransform: "capitalize",
//         }}
//       >
//         {/* {`Details for ${startCase(props.module)}`} */}
//       </Typography>

//       <Paper
//         elevation={0}
//         sx={{
//           padding: 5,
//           // borderRadius: '16px',
//           backgroundColor: "#f9fafc",
//           // boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
//         }}
//       >
//         {fields.length > 0 ? (
//           fields.map((field) => (
//             <Grid
//               container
//               key={field.key}
//               spacing={3}
//               sx={{ marginBottom: 2 }}
//             >
//               <Grid item xs={12} md={4}>
//                 <Typography
//                   variant="subtitle2"
//                   sx={{
//                     fontWeight: 500,
//                     fontSize: "13px",
//                     color: "#555",
//                     display: "flex",
//                     alignItems: "center",
//                   }}
//                 >
//                   {/* <InfoOutlinedIcon sx={{ marginRight: 1, color: 'rgba(0, 123, 255, 0.8)' }} /> */}
//                   {startCase(field.key.replaceAll("_", " "))}
//                 </Typography>
//               </Grid>
//               <Grid item xs={12} md={8}>
//                 <Typography
//                   variant="body1"
//                   sx={{
//                     fontSize: "13px",
//                     fontWeight: "400",
//                     backgroundColor: "#fff",
//                     padding: "3px",
//                     borderRadius: "1px",
//                     border: "1px solid #e0e0e0",
//                     // boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.05)',
//                     // color: '#333',
//                   }}
//                 >
//                   {renderField(field, formData[field.key])}
//                   {console.log("formData", formData)}
//                   {console.log(
//                     "field, formData[field.key]",
//                     field,
//                     formData[field.key]
//                   )}
//                 </Typography>
//               </Grid>
//             </Grid>
//           ))
//         ) : (
//           <Typography variant="body2" color="textSecondary">
//             No fields available.
//           </Typography>
//         )}
//       </Paper>

//       <Box display="flex" justifyContent="left" marginTop={4} paddingLeft={5}>
//         <Button
//           variant="outlined"
//           onClick={() => navigate("/" + props.module + "/edit/" + id)} // Replace with actual navigation
//           sx={{
//             color: "#DB561E",
//             borderColor: "#DB561E",
//             padding: "6px 12px",
//             fontSize: "16px",
//             fontWeight: 600,
//             textTransform: "capitalize",
//             "&:hover": {
//               color: "#FFFFFF",
//               backgroundColor: "#DB561E",
//               borderColor: "#FFFFFF",
//             },
//           }}
//         >
//           Edit
//         </Button>
//       </Box>
//     </Box>
//   );
// }






// *************************************with token ****************************************



import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { get, post, put } from "../../../utils/api";
import { startCase } from "lodash";
import { Typography, Box, Paper, Divider, Grid, Button } from "@mui/material";
import moment from "moment";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined"; // Use a modern icon for a premium look

export default function DetailsModule(props: any) {
  const { id } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState<any>({});
  const [fields, setFields] = useState<Array<any>>([]);
  const [token, setToken] = useState<string>("");

  useEffect(() => {
    getFields();
  }, [props.module]);

  const getFields = async () => {
    try {
      const response = await get(`${props.module}`, {});
      setFields(response.data.fields); // Set the field settings
      getData();
    } catch (error) {
      console.log("Error fetching fields: ", error);
    }
  };

  const getData = async () => {
    let params = { [props.primary_key]: id };
    try {
      const response = await get(`${props.module}/details`, params);
      setFormData(response.data); // Set the detailed form data
    } catch (error) {
      console.log("Error fetching data: ", error);
    }
  };

  const generateToken = async () => {
    try {
      const response: any = await post(`${props.module}/${id}`, {});
      console.log("response token", response);
      setToken(response.accessToken);

      // Update the formData with the new token
      setFormData((prev: any) => {
        const updatedFormData = { ...prev, token: response.accessToken };
        updateFormData(updatedFormData); // Pass updated data for the API call
        return updatedFormData; // Return the updated state
      });
    } catch (error) {
      console.log("Error fetching data: ", error);
    }
  };

  const updateFormData = async (updatedData: any) => {
    try {
      await put(`${props.module}/${id}`, updatedData);
    } catch (error) {
      console.error("Failed to update data:", error);
    }
  };

  const renderMappedObject = (
    mappedData: any[],
    primary_name_field: string
  ) => {
    if (!Array.isArray(mappedData) || mappedData.length === 0) {
      return "N/A";
    }

    return (
      <ul>
        {mappedData.map((item, index) => (
          <li key={index}>{item[primary_name_field] || "N/A"}</li>
        ))}
      </ul>
    );
  };

  const renderGenericTable = (data: Array<Record<string, any>>) => {
    if (!Array.isArray(data) || data.length === 0) {
      return <p>No data available.</p>;
    }

    const headers = Object.keys(data[0]);

    return (
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          marginBottom: "20px",
        }}
      >
        <thead>
          <tr>
            {headers.map((header, index) => (
              <th
                key={index}
                style={{
                  padding: "10px",
                  borderBottom: "2px solid #333",
                  textAlign: "left",
                  backgroundColor: "#f4f4f4",
                }}
              >
                {header.charAt(0).toUpperCase() + header.slice(1)}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {headers.map((header, colIndex) => (
                <td
                  key={colIndex}
                  style={{
                    padding: "10px",
                    borderBottom: "1px solid #ddd",
                  }}
                >
                  {row[header] !== null && row[header] !== undefined
                    ? row[header].toString()
                    : "N/A"}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  const renderField = (field: any, value: any) => {
    switch (field.type) {
      case "String":
        return value || "N/A";
      case "Number":
        return value || "N/A";
      case "Date":
        return value ? moment(value).format("DD-MMM-YYYY") : "N/A";
      case "Object":
        if (field.mapped_collection) {
          if (field.mapped_collection.multiple) {
            return renderMappedObject(
              value || [],
              field.mapped_collection.primary_name_field
            );
          }
          return value
            ? value[field.mapped_collection.primary_name_field]
            : "N/A";
        }
        return typeof value === "object" ? JSON.stringify(value, null, 2) : "N/A";
      default:
        return "N/A";
    }
  };

  return (
    <Box
      sx={{ marginTop: 4, paddingLeft: 3, paddingRight: 3, paddingBottom: 6 }}
    >
      {/* <Typography
        variant="h4"
        sx={{
          marginBottom: 4,
          fontWeight: "600",
          color: "#333",
          fontSize: "2.2rem",
          letterSpacing: "0.5px",
          textTransform: "capitalize",
        }}
      >
        {`Details for ${startCase(props.module)}`}
      </Typography> */}

      <Paper
        elevation={0}
        sx={{
          padding: 5,
          backgroundColor: "#f9fafc",
        }}
      >
        {fields.length > 0 ? (
          <>
            {fields.map((field) => (
              <Grid
                container
                key={field.key}
                spacing={3}
                sx={{ marginBottom: 2 }}
              >
                {/* <Grid item xs={12} md={4}> */}
                <Grid item xs={12} md={props.module === "app_clients" ? 3 : 4}>

                  <Typography
                    variant="subtitle2"
                    sx={{
                      fontWeight: 500,
                      fontSize: "13px",
                      color: "#555",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {startCase(field.key.replaceAll("_", " "))}
                  </Typography>
                </Grid>
                {/* <Grid item xs={12} md={8}> */}
                <Grid item xs={12} md={props.module === "app_clients" ? 6 : 8}>

                  <Typography
                    variant="body1"
                    sx={{
                      fontSize: formData[field.key]?.length > 100 ? "12px" : "13px", // Adjust font size based on content length
                      fontWeight: 400,
                      backgroundColor: "#fff",
                      padding: "3px",
                      borderRadius: "1px",
                      border: "1px solid #e0e0e0",
                      maxHeight: "200px", // Limit the height for long content
                      overflow: "auto", // Enable scroll for long content
                      whiteSpace: "pre-wrap", // Preserve formatting for large text
                      wordBreak: "break-word", // Prevent overflow from long words
                    }}
                  >
                    {renderField(field, formData[field.key])}
                  </Typography>


                </Grid>
              </Grid>
            ))}
            {/* <Grid container spacing={3}>

              {props.module === "app_clients" && !formData.token && (
                <Grid container spacing={3} sx={{ marginBottom: 2 }}>
                  <Grid item xs={12} md={4}>
                  </Grid>
                  <Grid item xs={12} md={8}>
                    <Button
                      variant="outlined"
                      onClick={generateToken}
                      sx={{
                        marginTop: 1,
                        color: "#DB561E",
                        borderColor: "#DB561E",
                        "&:hover": {
                          color: "#FFFFFF",
                          backgroundColor: "#DB561E",
                          borderColor: "#FFFFFF",
                        },
                      }}
                    >
                      Generate Token
                    </Button>
                  </Grid>
                </Grid>
              )}
            </Grid> */}

          </>
        ) : (
          <Typography variant="body2" color="textSecondary">
            No fields available.
          </Typography>
        )}
      </Paper>

      <Box display="flex" justifyContent="left" marginTop={4} paddingLeft={5}>
        <Button
          variant="outlined"
          onClick={() => navigate("/" + props.module + "/edit/" + id)}
          sx={{
            color: "#DB561E",
            borderColor: "#DB561E",
            padding: "6px 12px",
            fontSize: "16px",
            fontWeight: 600,
            textTransform: "capitalize",
            "&:hover": {
              color: "#FFFFFF",
              backgroundColor: "#DB561E",
              borderColor: "#FFFFFF",
            },
          }}
        >
          Edit
        </Button>
      </Box>
    </Box>
  );
}

